<template>
  <el-dialog :title="'【' + modelParam.task_id + '】' + modelParam.describe" center class="devOps-modelTwo"
    :visible.sync="dialogVisible" width="80%" top="10px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form" label-width="100px">
      <el-form-item label="分支" prop="branch">
        <el-select style="width:100%" v-model="form.branch" filterable placeholder="请输入开发项目Git分支">
          <el-option v-for="item in branchOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button :disabled="runLoading" type="warning" @click="onSubmit('run')">执行<i v-show="runLoading"
            class="el-icon-loading"></i></el-button>
        <el-button :disabled="skipLoading" type="warning" @click="onSubmit('skip')">跳过<i v-show="skipLoading"
            class="el-icon-loading"></i></el-button>
        <el-button type="info" @click="queryDevOpsSpaceListStageOutputApi">查看历史</el-button>
        <el-button type="success" v-if="reportUrl" @click="handleClickViewReport">查看报告</el-button>
        <el-button type="warning" @click="handleClose">返回</el-button>
      </el-form-item>
    </el-form>
    <Progress v-if="progressInfo.percentage" :progressInfo="progressInfo" />
    <TableOne v-if="tableData.length" :tableData="tableData" />
    <pre v-if="message" v-html="message" class="tips-message"></pre>
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
  getDevOpsSpaceListStageOutputApi,
  postODUDADcreateApi
} from "@/server/tops/devOps";
import { Progress } from "@/components/index.js";

import { TableOne } from "../table/index";
import { formatDate } from "../util";

export default {
  components: { TableOne, Progress },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () { };
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: {},
      rules: {
        branch: [{ required: true, message: "请输入分支", trigger: "blur" }],
      },
      message: "",
      runLoading: false,
      skipLoading: false,
      reportUrl: "",
      tableData: [],
      progressInfo: {
        customColor: "#1989fa",
        percentage: 0,
        title: "TOPS",
      },
      branchs: [],
      branchOptions: [],
    };
  },
  async mounted() {
    this.progressInfo.title = this.modelParam.module_name.toUpperCase();
    await this.queryDevOpsSpaceListStageParmInfo();
    await this.queryDevOpsSpaceStageSelectmapApi();
  },
  methods: {
    async queryDevOpsSpaceStageSelectmapApi() {
      const { module_name = "" } = this.modelParam || {};
      const ret = await postODUDADcreateApi({
        module_name: module_name || "BACKEND",
        domain:this.form.domain
      });
      this.branchs = this.branchOptions = ret.branchs.map((item) => {
        return { value: `${item}`, label: `${item}` };
      });
    },
    // 获取任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      const { stage_id, task_id } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          this.form = ret.data;
        } else {
          this.$notify({
            message: ret.error || "获取失败",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 获取历史执行信息
    async queryDevOpsSpaceListStageOutputApi() {
      this.message = "";
      const { stage_id = "", task_id = "" } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageOutputApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          let instance = JSON.parse(ret.data) || [];
          instance.map((item) => {
            return (item.content = JSON.stringify(item.output, null, 2));
          });
          this.message = instance.length ? "" : "暂无历史记录";
          this.tableData = instance;
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 关闭按钮
    handleClose() {
      this.hideDialogVisible("dialogVisible" + this.modelParam.stage);
    },
    // 提交
    async onSubmit(action) {
      this.reportUrl = "";
      action === "run" && (await this.queryActionRunSubmit("run"));
      action === "skip" && (await this.queryActionSkipSubmit("skip"));
    },
    // 执行接口调用
    async queryActionRunSubmit(action) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.progressInfo = {
            ...this.progressInfo,
            customColor: "#1989fa",
            percentage: 30,
            completeInfo: "",
          };
          const {
            stage_id = "",
            task_id = "",
            stage_name = "",
          } = this.modelParam;
          const { branch = "" } = this.form;
          const param = {
            action,
            stage_id,
            task_id,
            stage_name,
            branch,
          };
          this.runLoading = true;
          try {
            const cacheDate = new Date();
            const ret = await postDevopsSpaceStageActionApi(param);
            this.message = JSON.stringify(ret.data || "", null, 2);
            if (ret?.data?.output?.report?.length) {
              this.reportUrl = ret.data.output.report[0].url || "";
              let { report = [], runmsg = [] } = ret.data.output;
              if (
                report[0]?.code === 0 &&
                runmsg[0]?.code === 0 &&
                runmsg[1]?.code === 0 &&
                runmsg[2]?.code === 0 &&
                runmsg[3]?.code === 0
              ) {
                this.progressInfo = {
                  ...this.progressInfo,
                  customColor: "",
                  percentage: 100,
                  status: "success",
                  completeInfo:
                    "发布完成，用时：" +
                    formatDate(this, this.$moment(new Date()).diff(cacheDate)),
                };
              } else {
                this.progressInfo = {
                  ...this.progressInfo,
                  customColor: "",
                  percentage: 100,
                  status: "exception",
                  completeInfo: "发布失败，用时：" +
                    formatDate(this, this.$moment(new Date()).diff(cacheDate)),
                };
              }
            } else {
              this.progressInfo = {
                ...this.progressInfo,
                customColor: "",
                percentage: 100,
                status: "exception",
                completeInfo: "发布失败",
              };
            }
          } catch (error) {
            this.$notify({
              message: error || "操作失败",
              type: "error",
            });
          } finally {
            this.runLoading = false;
            this.tableData = [];
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 跳过接口调用
    async queryActionSkipSubmit(action) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const {
            stage_id = "",
            task_id = "",
            stage_name = "",
          } = this.modelParam;
          const { branch = "" } = this.form;
          const param = {
            action,
            stage_id,
            task_id,
            stage_name,
            branch,
          };
          try {
            this.skipLoading = true;
            const ret = await postDevopsSpaceStageActionApi(param);
            this.$notify({
              message: ret.status === "success" ? "跳过成功" : "跳过失败",
              type: ret.status === "success" ? "success" : "error",
            });
            ret.status === "success"
              ? this.hideDialogVisible("dialogVisible" + this.modelParam.stage)
              : (this.message = JSON.stringify(ret.data || "", null, 2));
          } catch (error) {
            this.$notify({
              message: error || "操作失败",
              type: "error",
            });
          } finally {
            this.skipLoading = false;
            this.tableData = [];
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClickViewReport() {
      let before = this.reportUrl.split('href=')[1];
      let reportUrl = before.split(' target=')[0]
      window.open(reportUrl);
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-message {
  max-height: 240px;
  overflow-y: scroll;
  white-space: pre-wrap;
  background: #f1fbec;
}
</style>
<style lang="scss">
.devOps-modelTwo {
  .el-input__inner {
    font-size: 14px !important;
  }

  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }

  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }

  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }

  .el-button {
    margin-right: 15px;
    letter-spacing: 2px;
    position: relative;

    .el-icon-loading {
      position: absolute;
      right: 5px;
    }
  }
}
</style>